<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-form-group label="Emails permitidos">
            <ValidationProvider name="emails" rules="">
                <b-form-textarea
                    id="emails-textarea"
                    v-model="emailsText"
                    :disabled="loading"
                    rows="6"
                    placeholder="Ingresá un email por línea"
                />
                <small class="text-muted">Un email por línea. Los duplicados y los inválidos se ignoran.</small>
            </ValidationProvider>
        </b-form-group>
        <b-col cols="12" class="text-right mt-4">
            <Button type="submit" name="button" :disabled="disabled">GUARDAR</Button>
        </b-col>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                emailsText: '',
            };
        },
        methods: {
            parseEmails(text) {
                return [...new Set(
                    text.split('\n')
                        .map(line => line.trim())
                        .filter(line => line.length > 0)
                )];
            },
            getValidEmails(emails) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emails.filter(e => emailRegex.test(e));
            },
            async submit() {
                const parsed = this.parseEmails(this.emailsText);
                const validEmails = this.getValidEmails(parsed);

                if (validEmails.length === 0) {
                    return;
                }

                this.$emit('terminado', validEmails);
                this.emailsText = '';
            }
        },
        computed: {
            disabled() {
                return !this.emailsText.trim() || this.loading;
            }
        }
    }
</script>

<style scoped>
</style>